import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

interface LanguageSelectorProps {
  scrolled?: boolean;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ scrolled = false }) => {
  const { i18n } = useTranslation();

  const languages = [
    { code: 'fr', label: 'FR', flag: '🇫🇷' },
    { code: 'en', label: 'EN', flag: '🇬🇧' },
    { code: 'zh', label: '中文', flag: '🇨🇳' }
  ];

  return (
    <div className="flex gap-3">
      {languages.map((lang) => (
        <motion.button
          key={lang.code}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => i18n.changeLanguage(lang.code)}
          className={`px-4 py-2 text-sm font-body tracking-wider transition-all duration-300 ${
            i18n.language === lang.code
              ? scrolled 
                ? 'bg-luxury-black text-luxury-champagne border border-luxury-black'
                : 'bg-luxury-gold text-luxury-black border border-luxury-gold'
              : scrolled
                ? 'bg-transparent text-luxury-black border border-luxury-gold/30 hover:border-luxury-gold hover:bg-luxury-gold/10'
                : 'bg-transparent text-luxury-cream border border-luxury-cream/30 hover:border-luxury-gold hover:text-luxury-gold'
          }`}
        >
          <span className="mr-2">{lang.flag}</span>
          {lang.label}
        </motion.button>
      ))}
    </div>
  );
};

export default LanguageSelector;